export function startWheatPasteEffect({ imgPanelEl }) {
  if (!imgPanelEl) return () => {};

  const canvas = imgPanelEl.querySelector('canvas.paste-brush-canvas');
  if (!canvas) return () => {};

  const ctx = canvas.getContext('2d');
  if (!ctx) return () => {};

  const resize = () => {
    const w = imgPanelEl.offsetWidth || 0;
    const h = imgPanelEl.offsetHeight || 0;
    if (w <= 0 || h <= 0) return;
    canvas.width = w;
    canvas.height = h;
  };

  resize();

  const observer = typeof ResizeObserver !== 'undefined' ? new ResizeObserver(resize) : null;
  if (observer) observer.observe(imgPanelEl);

  // Finite brush stroke animation
  const strokes = [];
  const strokeCount = 70;

  for (let i = 0; i < strokeCount; i++) {
    strokes.push({
      x: Math.random(),
      y: Math.random(),
      length: Math.random() * 220 + 110,
      angle: Math.random() * Math.PI * 2,
      width: Math.random() * 34 + 14,
      opacity: Math.random() * 0.28 + 0.12,
      delay: i * 55
    });
  }

  const startTime = Date.now();
  let rafId = 0;

  const draw = () => {
    const w = canvas.width;
    const h = canvas.height;
    if (w <= 0 || h <= 0) {
      rafId = requestAnimationFrame(draw);
      return;
    }

    ctx.clearRect(0, 0, w, h);

    const elapsed = Date.now() - startTime;

    // Brighter, glue-like strokes so the motion reads clearly.
    ctx.globalCompositeOperation = 'source-over';

    strokes.forEach((stroke) => {
      if (elapsed < stroke.delay) return;

      const progress = Math.min(1, (elapsed - stroke.delay) / 500);

      ctx.save();
      ctx.translate(stroke.x * w, stroke.y * h);
      ctx.rotate(stroke.angle);
      ctx.globalAlpha = stroke.opacity * progress;

      ctx.fillStyle = '#fff3b0';
      ctx.fillRect(0, -stroke.width / 2, stroke.length * progress, stroke.width);

      ctx.restore();
    });

    if (elapsed < strokeCount * 55 + 1600) {
      rafId = requestAnimationFrame(draw);
    }
  };

  rafId = requestAnimationFrame(draw);

  return () => {
    if (rafId) cancelAnimationFrame(rafId);
    if (observer) observer.disconnect();
  };
}
